import 'pixi.js';
import {View} from '@fantasmagames/slot/src/common/view/View';
import {SpinButtonViewEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonViewEvents';
import {ObjectSize, Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {SpinButton} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButton';
import {ButtonState} from '@fantasmagames/core/src/display/Button';

export class SpinButtonView extends View {
	public static readonly SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED: string = 'SpinButtonView::SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED';

	protected _spinButton: SpinButton;

	public init(): void {
		super.init();

		this.setupSpinButton();
	}

	public initAutoplay(): void {
		this.hideSpinButton();
	}

	public uninitAutoplay(): void {
		this.showSpinButton();
	}

	public hideSpinButton(): void {
		this._spinButton.visible = false;
	}

	public showSpinButton(): void {
		this._spinButton.visible = true;
	}

	public enableSpinButton(emitButtonBecameVisible: boolean = true): void {
		if (this._spinButton.visible && emitButtonBecameVisible) {
			this.emit(SpinButtonView.SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED);
		}
		this._spinButton.enable();
	}

	public disableSpinButton(): void {
		this._spinButton.disable();
	}

	public isSpinButtonVisibleAndEnabled(): boolean {
		return this._spinButton.currentState !== ButtonState.DISABLED && this._spinButton.interactive && this._spinButton.visible;
	}

	public spinButtonClickAction(): void {}

	protected setupSpinButton(): void {
		this._spinButton = new SpinButton(null, this.updateManager, this.resources);

		this.setupEventsForButtons();
		this.container.addChild(this._spinButton);
		this._spinButton.enable();

		const spinButtonPosition: Position = this.layout.getPosition('SPIN_BUTTON', this.viewType);
		this._spinButton.position.set(spinButtonPosition.x, spinButtonPosition.y);

		const size: ObjectSize = this.layout.getSize('SPIN_BUTTON', this.viewType);
		this._spinButton.hitArea = new PIXI.Circle(0, 0, size.width / 2);

		this.uninitAutoplay();
	}

	protected centerIn(source: PIXI.Sprite, parentWidth: number, parentHeight: number): PIXI.Sprite {
		source.x = parentWidth / 2 - source.width / 2;
		source.y = parentHeight / 2 - source.height / 2;

		return source;
	}

	protected addTint(source: PIXI.Sprite, tint: number): PIXI.Sprite {
		for (const child of source.children) {
			if (child instanceof PIXI.Sprite) {
				(child as PIXI.Sprite).tint = tint;
			}
		}

		return source;
	}

	protected setupEventsForButtons(): void {
		this._spinButton.callback = this.onSpinButtonClicked.bind(this);
	}

	protected onSpinButtonClicked(): void {
		this.emit(SpinButtonViewEvents.SPIN_BUTTON_CLICKED);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonView.ts